import { render, staticRenderFns } from "./Attente.vue?vue&type=template&id=9c7f5476&"
import script from "./Attente.vue?vue&type=script&lang=js&"
export * from "./Attente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports